<template>
    <CHeader
        fixed
        with-subheader
        light>
        <CSubheader class="d-flex justify-content-between align-items-center">
            <CHeaderBrand class="mx-auto d-lg-none mb__order-1" to="/">
                <img
                    src="/img/logo.svg"
                    alt="Logo"
                    class="logo" />
            </CHeaderBrand>
            <div class="d-flex justify-content-between align-items-center mb__order-3">
                <CToggler
                    in-header
                    class="ml-1 d-lg-none"
                    @click="$store.commit('toggleSidebarMobile')"
                />
                <CToggler
                    in-header
                    class="ml-3 d-md-down-none"
                    @click="$store.commit('toggleSidebarDesktop')"
                />
                <CustomBreadcrumbs class="border-0 mb-0" />
            </div>
            <CHeaderNav class="mr-4 mb__order-2">
                <TheHeaderDropdownAccnt />
            </CHeaderNav>
        </CSubheader>
    </CHeader>
</template>

<script>
    import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
    import CustomBreadcrumbs from '../components/CustomBreadcrumbs'

    export default {
        name: 'TheHeader',
        components: {
            TheHeaderDropdownAccnt,
            CustomBreadcrumbs
        },
    }
</script>
<style scoped>
.logo {
    display: block;
    width: 100%;
    max-width: 165px;
    padding: 0 10px;
}
@media (max-width: 991px) {
    .mb__order-1 {
        margin: 0 !important;
        order: 1;
    }
    .mb__order-2 {
        order: 2;
    }
    .mb__order-3 {
        width: 100%;
        justify-content: flex-start !important;
        order: 3;
    }
}
</style>
